'use strict'

import { format, sub } from 'date-fns';

import { initialiseElement as initScrollerElement } from '../modules/scroller';
import { loadComponent } from './utils/load-component';
import { getAllDigitalConcerts } from '../services/digital-inventory';
import zonedDate from '../utils/zoned-date';

const now = zonedDate();
const lastMonth = sub(now, {months: 1});
const thisYear = format(now, 'yyyy');

loadComponent('digital-calendar-scroller', {
    props: {
      pageId: {
          type: String,
          required: false
      }
    },
    data() {
        return {
            ViewModel: {
                Loading: true,
                Performances: [],
            }
        }
    },

    beforeMount() {
        getAllDigitalConcerts(parseInt(this.pageId, 10)).then(digitalConcertsResponse => {
            let perfs = digitalConcertsResponse.filter(item => {
                return item.type === 'video' && (!item.on_demand_end_date || zonedDate(item.on_demand_end_date) > now);
            })
                // Splits the concerts up to keep the most recent (going back 1 month)
                .reduce(
                    (carry, item) => {
                        const key = zonedDate(item.first_aired) > lastMonth ? 'upcoming' : 'past';
                        carry[key].push(item);
                        return carry;
                    },
                    {upcoming: [], past: []}
                );

            perfs.upcoming = perfs.upcoming.sort((a, b) => {
                // Upcoming events are ordered going forward
                return zonedDate(a.first_aired) > zonedDate(b.first_aired) ? 1 : -1;
            });
            perfs.past = perfs.past.sort((a, b) => {
                // Past events are ordered backwards
                return zonedDate(a.first_aired) < zonedDate(b.first_aired) ? 1 : -1;
            });

            if (perfs.past.length) {
                perfs.past[0].Spacer = {
                    Title: 'Past Concerts',
                };
            }

            perfs = [].concat(perfs.upcoming, perfs.past);

            this.ViewModel.Performances = perfs.map(item => {
                const date = zonedDate(item.first_aired);
                let month;

                if (format(date, 'yyyy') === thisYear) {
                    month = format(date, 'MMM d');
                } else {
                    month = format(date, 'MMM d yyyy');
                }

                return {
                    Spacer: item.Spacer ? item.Spacer : false,
                    ID: item.id,
                    Link: item.url,
                    Prefix: item.prefix,
                    Title: item.title,
                    Suffix: item.suffix,
                    Day: format(date, 'EEE'),
                    Month: month,
                    Time: format(date, 'h:mm aaa'),
                }
            });

            this.ViewModel.Loading = false;
        });
    },

    mounted() {
        const interval = setInterval(() => {
            if (this.ViewModel.Loading) {
                return;
            }

            clearInterval(interval);

            this.$nextTick(() => {
                if (this.$refs.swiper) {
                    initScrollerElement(this.$refs.swiper, {direction: 'vertical', slidesPerView: 4});
                }
            });
        }, 100);
    },
});
